import { type UseFormRegisterReturn } from 'react-hook-form'

interface SelectOption {
  value: string
  label: string
}

interface SelectFieldProps {
  label: string
  registration: UseFormRegisterReturn
  options: SelectOption[]
  error?: string
  required?: boolean
  placeholder?: string
  fullWidth?: boolean
}

function SelectField({
  label,
  registration,
  options,
  error,
  required = false,
  placeholder,
  fullWidth = false,
}: SelectFieldProps) {
  return (
    <div className={`mb-2 ${fullWidth ? 'md:col-span-2' : ''}`}>
      <label htmlFor={registration.name} className="block text-xs text-gray-600">
        {label}
        {required ? <span className="text-red-500"> *</span> : null}
      </label>
      <select
        id={registration.name}
        className={`w-full border-0 border-b bg-transparent px-0 py-2 text-sm text-gray-900 focus:border-b-2 focus:outline-none ${
          error ? 'border-red-500 focus:border-red-500' : 'border-gray-400 focus:border-blue-600'
        }`}
        {...registration}
      >
        <option value="">{placeholder ?? `Select: ${label}`}</option>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      {error ? <p className="mt-1 text-xs text-red-600">{error}</p> : null}
    </div>
  )
}

export default SelectField
